import * as React from 'react';
import { useIMask } from 'react-imask';
export const useInputMask = (mask) => {
    const options = typeof mask === 'string' ? { mask } : mask;
    const [opts] = React.useState(options);
    const { ref, maskRef, value, setValue, unmaskedValue, setUnmaskedValue, typedValue, setTypedValue, } = useIMask(opts, {
        onAccept() {
            return;
        },
    });
    return {
        ref,
        maskRef,
        value,
        setValue,
        unmaskedValue,
        setUnmaskedValue,
        typedValue,
        setTypedValue,
    };
};
//# sourceMappingURL=useInputMask.js.map